
{
  "familyId": "TAA-SIGNAALWOORD",
  "questions": [
    {
      "id": "TAA-SIGNAALWOORD-001",
      "familyId": "TAA-SIGNAALWOORD",
      "module": "Taalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_signaalwoorden",
      "questionType": "multiple_choice",
      "question": "Welk signaalwoord geeft een tegenstelling aan?",
      "context": "Het regende hard. Toch gingen we naar buiten.",
      "options": ["Toch", "Hard", "Naar", "We"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Signaalwoorden: tegenstelling",
            "content": "Tegenstellingswoorden geven aan dat iets anders is dan verwacht. Voorbeelden: toch, maar, echter, hoewel, ondanks, daarentegen. 'Toch' geeft aan: ondanks de regen gingen ze naar buiten.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "signal_word_contrast",
      "variantIndex": 1,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.79,
      "feedback": {
        "explanationText": "Signaalwoorden geven de relatie tussen zinnen aan. De eerste zin beschrijft regen (oorzaak om binnen te blijven). De tweede zin beschrijft het tegenovergestelde (naar buiten gaan). 'Toch' is het signaalwoord dat deze tegenstelling aangeeft.",
        "solutionSteps": [
          "Zoek het signaalwoord: 'toch'",
          "Eerste zin: regen → verwachting: binnen blijven",
          "Tweede zin: toch naar buiten → tegenstelling",
          "'Toch' = signaalwoord voor tegenstelling"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Toch' is een signaalwoord voor tegenstelling — het geeft aan dat iets anders gaat dan verwacht.",
          "1": "Je dacht waarschijnlijk dat 'hard' een signaalwoord is. Maar 'hard' is een bijwoord dat beschrijft hoe het regende. Onthoud: signaalwoorden verbinden zinnen, ze beschrijven niet.",
          "2": "Je dacht waarschijnlijk dat 'naar' een signaalwoord is. Maar 'naar' is een voorzetsel (richting). Onthoud: signaalwoorden geven de relatie tussen zinnen aan.",
          "3": "Je dacht waarschijnlijk dat 'we' een signaalwoord is. Maar 'we' is een voornaamwoord (persoon). Onthoud: signaalwoorden zijn woorden als maar, toch, want, dus."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.signaal-bijwoord-verward", "optionIndex": 1, "label": "Verwart bijwoord met signaalwoord" },
          { "id": "taa.signaal-voorzetsel-verward", "optionIndex": 2, "label": "Verwart voorzetsel met signaalwoord" },
          { "id": "taa.signaal-voornaamwoord-verward", "optionIndex": 3, "label": "Verwart voornaamwoord met signaalwoord" }
        ]
      }
    },
    {
      "id": "TAA-SIGNAALWOORD-002",
      "familyId": "TAA-SIGNAALWOORD",
      "module": "Taalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_signaalwoorden",
      "questionType": "multiple_choice",
      "question": "Welk signaalwoord geeft een oorzaak-gevolg aan?",
      "context": "De weg was glad. Daardoor slipte de auto.",
      "options": ["Daardoor", "Was", "Glad", "De"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Check-strategie: oorzaak en gevolg",
            "content": "Zoek naar het verband tussen twee gebeurtenissen. Vraag jezelf: 'Is het tweede een resultaat van het eerste?' Signaalwoorden als 'daarom', 'doordat' en 'hierdoor' wijzen op dit verband.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "signal_word_cause_effect",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Het woord 'daardoor' verbindt de oorzaak (de weg was glad) met het gevolg (de auto slipte). Het legt uit waarom iets gebeurt. Andere signaalwoorden voor oorzaak-gevolg zijn 'doordat', 'hierdoor', 'daarom' en 'zodat'. Check: kun je 'door' vervangen? Dan weet je zeker dat het een oorzaak-gevolg signaalwoord is.",
        "solutionSteps": [
          "Stel vast wat er eerst gebeurt (oorzaak): de weg was glad.",
          "Stel vast wat het resultaat is (gevolg): de auto slipte.",
          "Zoek het woord dat deze twee verbindt: 'daardoor'.",
          "Check: 'daardoor' bevat 'door' → oorzaak-gevolg."
        ],
        "distractorExplanations": {
          "0": "Goed! 'Daardoor' is het signaalwoord. Het verbindt de oorzaak (gladde weg) met het gevolg (slippende auto).",
          "1": "Je koos 'Was'. Maar 'was' is een werkwoord (persoonsvorm van 'zijn'), geen signaalwoord. Onthoud: signaalwoorden verbinden zinnen of zinsdelen, werkwoorden beschrijven een handeling of toestand.",
          "2": "Je koos 'Glad'. Maar 'glad' is een bijvoeglijk naamwoord dat een eigenschap van de weg beschrijft. Onthoud: signaalwoorden geven een verband aan tussen zinnen, bijvoeglijke naamwoorden beschrijven een zelfstandig naamwoord.",
          "3": "Je koos 'De'. Maar 'de' is een lidwoord dat bij 'weg' hoort. Onthoud: signaalwoorden geven het verband tussen zinnen aan (zoals daardoor, omdat, maar), lidwoorden staan altijd vóór een zelfstandig naamwoord."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.signaal-werkwoord-verward", "optionIndex": 1, "label": "Verwart werkwoord met signaalwoord" },
          { "id": "taa.signaal-bnw-verward", "optionIndex": 2, "label": "Verwart bijvoeglijk naamwoord met signaalwoord" },
          { "id": "taa.signaal-lidwoord-verward", "optionIndex": 3, "label": "Verwart lidwoord met signaalwoord" }
        ]
      }
    },
    {
      "id": "TAA-SIGNAALWOORD-003",
      "familyId": "TAA-SIGNAALWOORD",
      "module": "Taalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_signaalwoorden",
      "questionType": "text_highlight",
      "question": "Klik op het signaalwoord in deze zin:",
      "context": "We wilden gaan zwemmen, maar het zwembad was gesloten.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "We wilden gaan zwemmen, maar het zwembad was gesloten.",
        "correctHighlights": [{"start": 24, "end": 28}]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Signaalwoord herkennen",
            "content": "'Maar' is een signaalwoord voor tegenstelling. Het verbindt twee tegengestelde ideeën: willen zwemmen ↔ zwembad gesloten.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "signal_word_highlight",
      "variantIndex": 3,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "'Maar' is het signaalwoord. Het geeft een tegenstelling aan: ze wilden zwemmen (verwachting) ↔ het zwembad was gesloten (werkelijkheid).",
        "solutionSteps": [
          "Zoek het signaalwoord: 'maar'",
          "Verwachting: willen zwemmen",
          "Werkelijkheid: zwembad gesloten",
          "'Maar' = tegenstelling"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Maar' is het signaalwoord (tegenstelling)."
        }
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "TAA-SIGNAALWOORD-004",
      "familyId": "TAA-SIGNAALWOORD",
      "module": "Taalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_signaalwoorden",
      "questionType": "matching",
      "question": "Koppel elk signaalwoord aan het juiste type verband.",
      "context": null,
      "options": ["Match 1", "Match 2", "Match 3", "Match 4"],
      "correctAnswer": 0,
      "data": {
        "leftItems": ["Omdat", "Maar", "Bovendien", "Daarna"],
        "rightItems": ["Oorzaak-gevolg", "Tegenstelling", "Opsomming", "Tijd"],
        "correctMatches": {"0": 0, "1": 1, "2": 2, "3": 3}
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Soorten signaalwoorden",
            "content": "Oorzaak-gevolg: omdat, want, daardoor. Tegenstelling: maar, toch, echter. Opsomming: bovendien, ook, daarnaast. Tijd: daarna, vervolgens, ten slotte.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "signal_word_matching",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Omdat = oorzaak-gevolg (geeft een reden). Maar = tegenstelling (geeft een contrast). Bovendien = opsomming (voegt iets toe). Daarna = tijd (geeft volgorde aan).",
        "solutionSteps": [
          "Omdat → oorzaak-gevolg (waarom?)",
          "Maar → tegenstelling (onverwacht)",
          "Bovendien → opsomming (wat nog meer?)",
          "Daarna → tijd (wanneer?)"
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "TAA-SIGNAALWOORD-005",
      "familyId": "TAA-SIGNAALWOORD",
      "module": "Taalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_signaalwoorden",
      "questionType": "multiple_choice",
      "question": "Welk signaalwoord past het best? 'Eerst maakten we huiswerk. ___ gingen we buiten spelen.'",
      "context": null,
      "options": ["Daarna", "Omdat", "Maar", "Want"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "data": {
            "title": "Signaalwoord kiezen",
            "content": "De zinnen beschrijven een volgorde in tijd: eerst huiswerk, dan buiten spelen. 'Daarna' is het juiste tijdssignaalwoord.",
            "icon": "lightbulb"
          },
          "showWhen": "wrong"
        }
      ],
      "conceptId": "signal_word_choose",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Bepaal het verband tussen de zinnen. 'Eerst' geeft aan dat er een volgorde is. Na het huiswerk volgt buiten spelen. 'Daarna' is het tijdssignaalwoord dat deze volgorde aangeeft.",
        "solutionSteps": [
          "'Eerst' → er is een volgorde",
          "Na huiswerk volgt buiten spelen",
          "'Daarna' = tijdssignaalwoord voor volgorde"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Daarna' geeft de tijdsvolgorde aan: eerst huiswerk, daarna buiten spelen.",
          "1": "Je dacht waarschijnlijk dat 'omdat' past. Maar 'omdat' geeft een reden aan, en de zinnen beschrijven een volgorde, geen oorzaak. Onthoud: volgorde = daarna, vervolgens.",
          "2": "Je dacht waarschijnlijk dat 'maar' past. Maar 'maar' geeft een tegenstelling aan, en er is hier geen tegenstelling. Onthoud: beide activiteiten gebeuren gewoon na elkaar.",
          "3": "Je dacht waarschijnlijk dat 'want' past. Maar 'want' geeft een reden aan, en de zinnen beschrijven een volgorde. Onthoud: volgorde = daarna, vervolgens."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.signaal-oorzaak-als-tijd", "optionIndex": 1, "label": "Kiest oorzaak-signaalwoord waar tijdssignaalwoord past" },
          { "id": "taa.signaal-tegenstelling-als-tijd", "optionIndex": 2, "label": "Kiest tegenstelling-signaalwoord waar tijdssignaalwoord past" },
          { "id": "taa.signaal-reden-als-tijd", "optionIndex": 3, "label": "Kiest reden-signaalwoord waar tijdssignaalwoord past" }
        ]
      }
    },
    {
      "id": "TAA-SIGNAALWOORD-009",
      "familyId": "TAA-SIGNAALWOORD",
      "module": "Taalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_signaalwoorden",
      "questionType": "true_false_series",
      "question": "Zijn deze stellingen over signaalwoorden waar of onwaar?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "'Daarom' is een signaalwoord voor een oorzaak of reden.", "isTrue": true },
          { "text": "'Maar' is een signaalwoord voor een opsomming.", "isTrue": false },
          { "text": "'Ten eerste' is een signaalwoord voor een volgorde.", "isTrue": true },
          { "text": "'Omdat' is een signaalwoord voor een tegenstelling.", "isTrue": false }
        ]
      },
      "conceptId": "signal_word_true_false",
      "variantIndex": 9,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Signaalwoorden geven een verband aan. 'Daarom' geeft een reden aan. 'Maar' geeft een tegenstelling aan (geen opsomming). 'Ten eerste' geeft een volgorde aan. 'Omdat' geeft een reden aan (geen tegenstelling).",
        "solutionSteps": [
          "'Daarom' = reden (Waar)",
          "'Maar' = tegenstelling, niet opsomming (Onwaar)",
          "'Ten eerste' = volgorde (Waar)",
          "'Omdat' = reden, niet tegenstelling (Onwaar)"
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "TAA-SIGNAALWOORD-010",
      "familyId": "TAA-SIGNAALWOORD",
      "module": "Taalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_signaalwoorden",
      "questionType": "categorize",
      "question": "Sorteer de signaalwoorden bij het juiste verband.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Tegenstelling", "Opsomming", "Oorzaak/Reden"],
        "items": [
          { "text": "maar", "correctCategory": 0 },
          { "text": "en", "correctCategory": 1 },
          { "text": "omdat", "correctCategory": 2 },
          { "text": "echter", "correctCategory": 0 },
          { "text": "ook", "correctCategory": 1 },
          { "text": "want", "correctCategory": 2 }
        ]
      },
      "conceptId": "signal_word_categorize",
      "variantIndex": 10,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Tegenstelling: maar, echter, toch. Opsomming: en, ook, bovendien. Oorzaak/reden: omdat, want, daarom.",
        "solutionSteps": [
          "Tegenstelling: woorden die een contrast aangeven (maar, echter)",
          "Opsomming: woorden die iets toevoegen (en, ook)",
          "Oorzaak/reden: woorden die uitleggen waarom (omdat, want)"
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "TAA-SIGNAALWOORD-011",
      "familyId": "TAA-SIGNAALWOORD",
      "module": "Taalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_signaalwoorden",
      "questionType": "ordering",
      "question": "Zet deze zinnen in de juiste volgorde. Let op de signaalwoorden!",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": [
          "Ten eerste maakte Lisa haar huiswerk.",
          "Vervolgens ruimde ze haar kamer op.",
          "Daarna ging ze naar buiten.",
          "Ten slotte at ze samen met haar familie."
        ],
        "correctOrder": [0, 1, 2, 3]
      },
      "conceptId": "signal_word_ordering_time",
      "variantIndex": 11,
      "citoDifficulty": 0.33,
      "citoDiscrimination": 0.77,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tijdssignaalwoorden en volgorde",
            "content": "Tijdssignaalwoorden geven de volgorde aan: ten eerste → vervolgens → daarna → ten slotte. 'Ten eerste' = het begin, 'ten slotte' = het einde.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De tijdssignaalwoorden geven de volgorde aan. 'Ten eerste' = de eerste stap. 'Vervolgens' = wat daarna komt. 'Daarna' = de volgende stap. 'Ten slotte' = de laatste stap. Zo weet je precies in welke volgorde alles gebeurde.",
        "solutionSteps": [
          "Ten eerste = begin (stap 1)",
          "Vervolgens = daarna (stap 2)",
          "Daarna = volgende (stap 3)",
          "Ten slotte = einde (stap 4)"
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "TAA-SIGNAALWOORD-012",
      "familyId": "TAA-SIGNAALWOORD",
      "module": "Taalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_signaalwoorden",
      "questionType": "fill_in",
      "question": "Vul het juiste signaalwoord in: 'De trein had vertraging. ___ kwamen we te laat op school.' Welk signaalwoord past hier?",
      "options": [],
      "correctAnswer": "Daardoor",
      "data": {
        "acceptedAnswers": ["Daardoor", "daardoor", "Hierdoor", "hierdoor", "Daarom", "daarom"],
        "caseSensitive": false,
        "placeholder": "signaalwoord"
      },
      "conceptId": "signal_word_fill_in_cause",
      "variantIndex": 12,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.76,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Signaalwoord invullen",
            "content": "Bepaal het verband: de vertraging (oorzaak) leidde tot te laat komen (gevolg). Bij oorzaak-gevolg passen: daardoor, hierdoor, daarom. 'Daardoor' past het best: het geeft aan dat het gevolg direct door de oorzaak komt.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "De trein had vertraging (oorzaak) en daardoor kwamen ze te laat (gevolg). 'Daardoor' is een signaalwoord voor oorzaak-gevolg. Ook 'hierdoor' en 'daarom' zijn correct — ze geven allemaal aan dat het ene het gevolg is van het andere.",
        "solutionSteps": [
          "Oorzaak: de trein had vertraging",
          "Gevolg: te laat op school",
          "Verband = oorzaak-gevolg",
          "Passende signaalwoorden: daardoor, hierdoor, daarom"
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "TAA-SIGNAALWOORD-013",
      "familyId": "TAA-SIGNAALWOORD",
      "module": "Taalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_signaalwoorden",
      "questionType": "multiple_choice",
      "question": "Welk verband geeft het signaalwoord 'daardoor' aan?",
      "context": "De zon scheen fel. Daardoor smolt het ijs op het meer.",
      "options": ["Oorzaak-gevolg", "Tijd", "Tegenstelling", "Toevoeging"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Signaalwoord 'daardoor'",
            "content": "'Daardoor' verbindt een oorzaak met een gevolg. Oorzaak = de zon scheen fel. Gevolg = het ijs smolt. 'Daardoor' is dus een oorzaak-gevolg-signaalwoord.",
            "icon": "lightbulb"
          }
        },
        {
          "type": "signalWordCard",
          "showWhen": "wrong",
          "data": {
            "word": "daardoor",
            "function": "oorzaak-gevolg",
            "example": "De zon scheen fel. Daardoor smolt het ijs op het meer.",
            "label": "Signaalwoord"
          }
        }
      ],
      "conceptId": "signal_word_function_card",
      "variantIndex": 13,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "'Daardoor' geeft altijd oorzaak-gevolg aan: door de hete zon (oorzaak) smolt het ijs (gevolg).",
        "solutionSteps": [
          "Oorzaak: de zon scheen fel",
          "Gevolg: het ijs smolt",
          "'Daardoor' = oorzaak-gevolg"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Daardoor' is een klassiek oorzaak-gevolg signaalwoord.",
          "1": "'Daardoor' geeft geen tijd aan. Tijdssignaalwoorden zijn bijvoorbeeld 'daarna' of 'vervolgens'.",
          "2": "'Daardoor' geeft geen tegenstelling aan. Tegenstellingswoorden zijn bijvoorbeeld 'maar' of 'toch'.",
          "3": "'Daardoor' is geen toevoeging. Toevoegingen zijn bijvoorbeeld 'bovendien' of 'ook'."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.signaal-oorzaak-als-tijd", "optionIndex": 1, "label": "Verwart oorzaak-gevolg met tijd" },
          { "id": "taa.signaal-oorzaak-als-tegenstelling", "optionIndex": 2, "label": "Verwart oorzaak-gevolg met tegenstelling" },
          { "id": "taa.signaal-oorzaak-als-toevoeging", "optionIndex": 3, "label": "Verwart oorzaak-gevolg met toevoeging" }
        ]
      }
    },
    {
      "id": "TAA-SIGNAALWOORD-014",
      "familyId": "TAA-SIGNAALWOORD",
      "module": "Taalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_signaalwoorden",
      "questionType": "multiple_choice",
      "question": "Welk verband geeft het signaalwoord 'maar' aan?",
      "context": "Tom wilde naar buiten. Maar het regende hard.",
      "options": ["Tegenstelling", "Oorzaak-gevolg", "Tijd", "Toevoeging"],
      "correctAnswer": 0,
      "data": {
        "mode": "icon_chips",
        "optionIcons": ["Scale", "ArrowRight", "Clock", "Plus"]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Signaalwoord 'maar'",
            "content": "'Maar' verbindt twee zinnen die elkaar tegenspreken. Tom wilde naar buiten ↔ het regende. 'Maar' is dus een tegenstelling-signaalwoord.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "signal_word_function_chips",
      "variantIndex": 14,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "'Maar' geeft altijd een tegenstelling aan: Tom wilde iets, en het tegenovergestelde gebeurde. De vier signaalwoord-functies zijn tegenstelling, oorzaak-gevolg, tijd en toevoeging.",
        "solutionSteps": [
          "Zin 1: Tom wilde naar buiten",
          "Zin 2: het regende hard",
          "De zinnen spreken elkaar tegen",
          "'Maar' = tegenstelling"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Maar' is het klassieke tegenstelling-signaalwoord.",
          "1": "'Maar' geeft geen oorzaak-gevolg aan. Daarvoor gebruik je 'daardoor' of 'omdat'.",
          "2": "'Maar' geeft geen tijd aan. Tijdssignaalwoorden zijn 'daarna' of 'vervolgens'.",
          "3": "'Maar' is geen toevoeging. Toevoegingen zijn 'bovendien' of 'ook'."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.signaal-tegenstelling-als-oorzaak", "optionIndex": 1, "label": "Verwart tegenstelling met oorzaak-gevolg" },
          { "id": "taa.signaal-tegenstelling-als-tijd", "optionIndex": 2, "label": "Verwart tegenstelling met tijd" },
          { "id": "taa.signaal-tegenstelling-als-toevoeging", "optionIndex": 3, "label": "Verwart tegenstelling met toevoeging" }
        ]
      }
    },
    {
      "id": "TAA-SIGNAALWOORD-015",
      "familyId": "TAA-SIGNAALWOORD",
      "module": "Taalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_signaalwoorden",
      "questionType": "multiple_choice",
      "question": "Welk verband geeft het signaalwoord 'omdat' aan?",
      "context": "Sara bleef thuis omdat ze ziek was.",
      "options": ["Oorzaak-gevolg", "Tegenstelling", "Tijd", "Toevoeging"],
      "correctAnswer": 0,
      "data": {
        "mode": "icon_chips",
        "optionIcons": ["ArrowRight", "Scale", "Clock", "Plus"]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Signaalwoord 'omdat'",
            "content": "'Omdat' verbindt een gevolg met een reden. Gevolg = Sara bleef thuis. Reden = ze was ziek. 'Omdat' is dus een oorzaak-gevolg-signaalwoord (het geeft de reden).",
            "icon": "lightbulb"
          }
        },
        {
          "type": "signalWordCard",
          "showWhen": "wrong",
          "data": {
            "word": "omdat",
            "function": "oorzaak-gevolg",
            "example": "Sara bleef thuis omdat ze ziek was.",
            "label": "Signaalwoord"
          }
        }
      ],
      "conceptId": "signal_word_function_chips_cause",
      "variantIndex": 15,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "'Omdat' geeft altijd een reden aan: Sara bleef thuis (gevolg) omdat ze ziek was (oorzaak). De vier signaalwoord-functies zijn tegenstelling, oorzaak-gevolg, tijd en toevoeging.",
        "solutionSteps": [
          "Zin 1: Sara bleef thuis (gevolg)",
          "Zin 2: ze was ziek (reden)",
          "'Omdat' verbindt reden en gevolg",
          "'Omdat' = oorzaak-gevolg"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Omdat' is een klassiek oorzaak-gevolg signaalwoord — het geeft altijd een reden.",
          "1": "'Omdat' geeft geen tegenstelling aan. Tegenstellingswoorden zijn 'maar' of 'toch'.",
          "2": "'Omdat' geeft geen tijd aan. Tijdssignaalwoorden zijn 'daarna' of 'vervolgens'.",
          "3": "'Omdat' is geen toevoeging. Toevoegingen zijn 'bovendien' of 'ook'."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.signaal-oorzaak-als-tegenstelling", "optionIndex": 1, "label": "Verwart oorzaak-gevolg met tegenstelling" },
          { "id": "taa.signaal-oorzaak-als-tijd", "optionIndex": 2, "label": "Verwart oorzaak-gevolg met tijd" },
          { "id": "taa.signaal-oorzaak-als-toevoeging", "optionIndex": 3, "label": "Verwart oorzaak-gevolg met toevoeging" }
        ]
      }
    },
    {
      "id": "TAA-SIGNAALWOORD-016",
      "familyId": "TAA-SIGNAALWOORD",
      "module": "Taalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_signaalwoorden",
      "questionType": "multiple_choice",
      "question": "Welk verband geeft het signaalwoord 'vervolgens' aan?",
      "context": "We pakten onze rugzak. Vervolgens stapten we op de fiets.",
      "options": ["Tijd", "Tegenstelling", "Oorzaak-gevolg", "Toevoeging"],
      "correctAnswer": 0,
      "data": {
        "mode": "icon_chips",
        "optionIcons": ["Clock", "Scale", "ArrowRight", "Plus"]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Signaalwoord 'vervolgens'",
            "content": "'Vervolgens' geeft de volgorde in tijd aan. Eerst rugzak pakken, daarna op de fiets stappen. 'Vervolgens' is dus een tijdssignaalwoord — net als 'daarna', 'eerst', 'ten slotte'.",
            "icon": "lightbulb"
          }
        },
        {
          "type": "signalWordCard",
          "showWhen": "wrong",
          "data": {
            "word": "vervolgens",
            "function": "tijd",
            "example": "We pakten onze rugzak. Vervolgens stapten we op de fiets.",
            "label": "Signaalwoord"
          }
        }
      ],
      "conceptId": "signal_word_function_chips_time",
      "variantIndex": 16,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "'Vervolgens' geeft altijd een volgorde in tijd aan: eerst de ene actie, dan de volgende. De vier signaalwoord-functies zijn tegenstelling, oorzaak-gevolg, tijd en toevoeging.",
        "solutionSteps": [
          "Actie 1: rugzak pakken",
          "Actie 2: op de fiets stappen",
          "Tussen de acties zit een volgorde",
          "'Vervolgens' = tijd"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Vervolgens' is een tijdssignaalwoord — het geeft de volgorde van acties aan.",
          "1": "'Vervolgens' geeft geen tegenstelling aan. Tegenstellingswoorden zijn 'maar' of 'toch'.",
          "2": "'Vervolgens' geeft geen oorzaak-gevolg aan. Daarvoor gebruik je 'daardoor' of 'omdat'.",
          "3": "'Vervolgens' is geen toevoeging. Toevoegingen zijn 'bovendien' of 'ook'."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.signaal-tijd-als-tegenstelling", "optionIndex": 1, "label": "Verwart tijd met tegenstelling" },
          { "id": "taa.signaal-tijd-als-oorzaak", "optionIndex": 2, "label": "Verwart tijd met oorzaak-gevolg" },
          { "id": "taa.signaal-tijd-als-toevoeging", "optionIndex": 3, "label": "Verwart tijd met toevoeging" }
        ]
      }
    },
    {
      "id": "TAA-SIGNAALWOORD-017",
      "familyId": "TAA-SIGNAALWOORD",
      "module": "Taalbegrip",
      "tier": 10,
      "levelCode": "M7+",
      "group": 7,
      "skill": "tekstbegrip",
      "subSkill": "tekst_signaalwoorden",
      "questionType": "multiple_choice",
      "question": "Welk verband geeft het signaalwoord 'bovendien' aan?",
      "context": "De film was spannend. Bovendien zat er een verrassend einde aan.",
      "options": ["Toevoeging", "Tegenstelling", "Oorzaak-gevolg", "Tijd"],
      "correctAnswer": 0,
      "data": {
        "mode": "icon_chips",
        "optionIcons": ["Plus", "Scale", "ArrowRight", "Clock"]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Signaalwoord 'bovendien'",
            "content": "'Bovendien' voegt iets extra's toe. De film was al spannend, en dáár komt het verrassende einde nog bij. Toevoegings-signaalwoorden zijn ook 'ook', 'daarnaast', 'verder'.",
            "icon": "lightbulb"
          }
        },
        {
          "type": "signalWordCard",
          "showWhen": "wrong",
          "data": {
            "word": "bovendien",
            "function": "toevoeging",
            "example": "De film was spannend. Bovendien zat er een verrassend einde aan.",
            "label": "Signaalwoord"
          }
        }
      ],
      "conceptId": "signal_word_function_chips_add",
      "variantIndex": 17,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.79,
      "feedback": {
        "explanationText": "'Bovendien' voegt altijd iets extra's toe aan wat er al gezegd is. Zin 1 noemt één eigenschap, zin 2 voegt er een tweede aan toe. De vier signaalwoord-functies zijn tegenstelling, oorzaak-gevolg, tijd en toevoeging.",
        "solutionSteps": [
          "Eigenschap 1: de film was spannend",
          "Eigenschap 2: verrassend einde",
          "'Bovendien' stapelt eigenschap 2 op eigenschap 1",
          "'Bovendien' = toevoeging"
        ],
        "distractorExplanations": {
          "0": "Goed! 'Bovendien' is een toevoegings-signaalwoord — het stapelt informatie op elkaar.",
          "1": "'Bovendien' geeft geen tegenstelling aan. Tegenstellingswoorden zijn 'maar' of 'toch'.",
          "2": "'Bovendien' geeft geen oorzaak-gevolg aan. Daarvoor gebruik je 'daardoor' of 'omdat'.",
          "3": "'Bovendien' geeft geen tijd aan. Tijdssignaalwoorden zijn 'daarna' of 'vervolgens'."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "taa.signaal-toevoeging-als-tegenstelling", "optionIndex": 1, "label": "Verwart toevoeging met tegenstelling" },
          { "id": "taa.signaal-toevoeging-als-oorzaak", "optionIndex": 2, "label": "Verwart toevoeging met oorzaak-gevolg" },
          { "id": "taa.signaal-toevoeging-als-tijd", "optionIndex": 3, "label": "Verwart toevoeging met tijd" }
        ]
      }
    }
  ]
}
